var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.dialogName,{tag:"component",attrs:{"open":_vm.open,"data":_vm.data},on:{"update:open":function($event){_vm.open=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }